// Dati FAQ Argus condivisi tra la landing (client) e la pagina (server, per lo schema FAQPage).
// Modulo neutro (no "use client") cosi' il valore e' reale anche lato server.

export const ARGUS_FAQ = [
  {
    q: "È davvero gratis?",
    a: "Sì, completamente. Niente account, niente abbonamento, niente limite al numero di siti che analizzi. È nata come alternativa libera a Wappalyzer, che dal 2023 è diventato a pagamento.",
  },
  {
    q: "Raccoglie i miei dati?",
    a: "No. Argus lavora interamente sul tuo computer: non ha server, non salva i tuoi dati altrove, non usa sistemi di tracciamento. I risultati restano nel popup, visibili solo a te.",
  },
  {
    q: "Come fa a sapere lo stack di un sito?",
    a: "Legge in locale ciò che il sito espone già pubblicamente, come il codice della pagina, gli header della risposta e alcune variabili tecniche, e li confronta con un database di oltre 7.500 tecnologie per riconoscere cosa è stato usato.",
  },
  {
    q: "Funziona su tutti i siti?",
    a: "Funziona sulla grande maggioranza dei siti web. Su alcuni progetti molto personalizzati o protetti il riconoscimento può essere parziale, ma i dati pubblici dell'azienda e del dominio restano comunque disponibili.",
  },
  {
    q: "È un'alternativa a Wappalyzer?",
    a: "Sì. Fa quello che cercavi in Wappalyzer, ma in locale, gratis e senza limiti, e in più estrae i dati pubblici dell'azienda dietro al dominio con verifica della partita IVA su VIES.",
  },
];
